var _filter, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "inset-shadow"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "offset-blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "offset-blur",
    result: "inverse"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "black",
    floodOpacity: 0.95,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color",
    in2: "inverse",
    result: "shadow"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "over",
    in: "shadow",
    in2: "SourceGraphic"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    filter: "url(#inset-shadow)",
    d: "M7.032 0C6.74092 0 6.45383 0.0677722 6.19348 0.197949C5.93312 0.328126 5.70665 0.517132 5.532 0.75L0.186002 7.875C0.0648292 8.03747 -0.000430822 8.23482 2.14049e-06 8.4375V28.125C2.14049e-06 28.6223 0.197546 29.0992 0.549177 29.4508C0.900808 29.8025 1.37772 30 1.875 30H28.125C28.6223 30 29.0992 29.8025 29.4508 29.4508C29.8025 29.0992 30 28.6223 30 28.125V8.4375C30 8.23465 29.9342 8.03728 29.8125 7.875L24.468 0.75C24.2934 0.517132 24.0669 0.328126 23.8065 0.197949C23.5462 0.0677722 23.2591 0 22.968 0H7.032ZM28.125 8.751V9.375H1.875V8.751L2.8125 7.5H14.0625V1.875H15.9375V7.5H27.1875L28.125 8.751Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox1);
export default __webpack_public_path__ + "static/media/box 1.dd816dd7ada9930676abe12d02d8ff55.svg";
export { ForwardRef as ReactComponent };